import qs from 'qs'

import { getPodsFilterState } from 'app/features/teams/messages/table-filters/PodsFilter'
import { getManagerFilterState } from 'app/features/teams/messages/table-filters/PropertyManagerFilter'
import {
  getCorrespondingMgmtTypeValue,
  getMgmtTypeFilterState,
} from 'app/pages/teams/messages'
import * as sharedHelpers from 'app/shared_components/helpers'
import { apiBaseUrl } from 'app/shared_components/shared_base_url'

export const getTeamApplications = (agencyID, filters) => {
  const defaultedFilters = {
    archived: false,
    cursor: '',
    manager: '',
    limit: 10,
    searchText: '',
    applicantEmail: '',
    mgmtType: 0,
    ...filters,
  }
  const { mgmtType } = filters
  const { searchText, manager, pods, sort, ...otherFilters } = defaultedFilters
  let mappedFilters = {
    ...otherFilters,
    q: searchText,
  }

  let searchParams = new URLSearchParams()
  const podsFilter = getPodsFilterState(pods)
  const managerFilter = getManagerFilterState(manager)
  managerFilter?.forEach((managerGUID) =>
    searchParams.append('manager', managerGUID),
  )
  podsFilter?.forEach((podId) => searchParams.append('pods', podId))

  const mgmtTypeFilter = getCorrespondingMgmtTypeValue(
    getMgmtTypeFilterState(mgmtType),
  )

  mgmtTypeFilter?.forEach((mgmtType) =>
    searchParams.append('mgmtType', mgmtType),
  )

  let filtersQuery = searchParams.toString()

  filtersQuery += `&${qs.stringify(mappedFilters, { arrayFormat: 'repeat' })}`
  const url = `${apiBaseUrl}sm/teams/${agencyID}/applications?${filtersQuery}`
  const options = {
    method: 'GET',
    credentials: 'include',
  }
  return fetch(url, options)
    .then(sharedHelpers.checkStatus)
    .then(
      (responseData) => ({ ok: true, responseData }),
      sharedHelpers.returnAPIError,
    )
    .catch(sharedHelpers.logAPIError)
}
